import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	body: {
		id: 'schools.heroBody',
		defaultMessage: 'Join 250,000+ teachers bringing mindfulness to the next generation',
		description: 'Calm Schools hero body text',
	},
	cta: {
		id: 'schools.heroCtaButton',
		defaultMessage: 'Join the movement',
		description: 'Calm Schools button cta',
	},
});
